module.exports = __webpack_public_path__ + "static/media/emotions-min.200808be.jpg";